import { render } from "./SectionContact.vue?vue&type=template&id=4bbf70ba"
const script = {}

import exportComponent from "C:\\OpenServer\\domains\\ar-esqrd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__